module.exports = __webpack_public_path__ + "assets/img/323d2f09e875c84fad850b022cac9a92.png";